<template>
    <div class="bg-white shadow-lg sm:rounded-md border border-gray-200 mb-4">
        <div class="overflow-x-auto">

            <div
                class="flex justify-between items-center p-2 tracking-widest"
                :class="[backgroundClass, textClass]"
            >
                <div class="justify-start font-bold">
                    <slot name="title" />
                </div>

                <div class="justify-end">
                    <slot name="headerButtons" />
                </div>
            </div>

            <!-- SEARCH DISPLAY -->
            <div class="p-2" v-if="hasSearch">
                <span class="font-semibold text-sm mr-2">Critères de recherche:</span>

                <span v-for="(search, index) in searchParams" :key="'s-'+index">
                    <span
                        v-if="search.value"
                        class="px-2 py-1 text-small rounded-full text-white bg-red-600 mr-2"
                    >
                        {{ search.label }} {{ search.value }}
                        <i
                            @click="removeSearch(index)"
                            class="fad fa-times-circle ml-2 cursor-pointer"
                        />
                    </span>
                </span>

                <span v-for="(filter, index) in filters" :key="'f-'+index">
                    <span v-if="filter.value">

                        <span
                            v-if="Array.isArray(filter.value)"
                            v-for="v in filter.value"
                            :key="v"
                            class="px-2 py-1 text-xs rounded-full text-white bg-red-600 mr-2"
                        >
                            {{ filter.label }} : {{ filter.options[v] }}
                            <i
                                @click="removeFilter(index, v)"
                                class="fad fa-times-circle ml-2 cursor-pointer"
                            />
                        </span>

                        <span
                            v-else
                            class="px-2 py-1 text-xs rounded-full text-white bg-red-600 mr-2"
                        >
                            {{ filter.label }} : {{ filter.options[filter.value] }}
                            <i
                                @click="removeFilter(index)"
                                class="fad fa-times-circle ml-2 cursor-pointer"
                            />
                        </span>

                    </span>
                </span>
            </div>

            <!-- TABLE -->
            <table class="w-full">
                <thead class="bg-gray-200">
                    <slot name="tableHeader" />
                </thead>

                <tbody>
                    <slot name="tableBody" />
                </tbody>
            </table>

        </div>
    </div>
</template>

<script>
    import qs from "qs";
    import InteractWIthFilterMixins from "@/Mixins/InteractWIthFilterMixins";

    export default {
        mixins: [InteractWIthFilterMixins],

        props: {
            backgroundClass: {
                type: String,
                default: "bg-sky"
            },
            textClass: {
                type: String,
                default: "text-white"
            }
        },

        data() {
            return {
                searchParams: {},
                filters: {},
                hasSearch: null
            };
        },

        mounted() {
            const qbp = this.getQueryBuilderProps();

            this.searchParams = { ...(qbp.search || {}) };
            this.filters = { ...(qbp.filters || {}) };

            this.getSearchData();
        },

        methods: {
            /**
             * SAFE ACCESS Inertia props
             */
            getQueryBuilderProps() {
                return this.$page?.props?.queryBuilderProps ?? {
                    search: {},
                    filters: {}
                };
            },

            getSearchData() {
                if (!window.location.search) return;

                const params = qs.parse(window.location.search.substring(1));

                this.hasSearch = null;

                if (params.filter) {
                    this.hasSearch = params.filter;

                    for (const [key, value] of Object.entries(params.filter)) {

                        if (this.searchParams[key]) {
                            this.searchParams[key].value = value;
                        }

                        if (this.filters[key]) {
                            let filterValue = "";

                            if (this.filters[key].config?.mode === "tags") {
                                filterValue = value.split(",");
                            } else {
                                filterValue = value;
                            }

                            this.filters[key].value = filterValue;
                        }
                    }
                }
            },

            removeSearch(index) {
                const qbp = this.getQueryBuilderProps();

                if (qbp.search?.[index]) {
                    this.$page.props.queryBuilderProps.search[index].value = null;
                }

                if (this.searchParams[index]) {
                    this.searchParams[index].value = null;
                }

                this.search();
            },

            removeFilter(index, val = null) {
                let filter = null;

                if (Array.isArray(this.filters[index]?.value)) {
                    filter = this.filters[index].value.filter(v => v !== val);
                }

                this.filters[index].value = filter;

                if (this.$page?.props?.queryBuilderProps?.filters?.[index]) {
                    this.$page.props.queryBuilderProps.filters[index].value = filter;
                }

                this.search(false);
            }
        },

        watch: {
            $page() {
                const qbp = this.getQueryBuilderProps();

                this.searchParams = { ...(qbp.search || {}) };
                this.filters = { ...(qbp.filters || {}) };

                this.getSearchData();
            }
        }
    };
</script>

<style scoped>
    table :deep(th) {
        font-size: 0.65rem;
        line-height: 1rem;
        padding: 0.5rem 0.7rem;
        text-align: center;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }

    tbody :deep(td) {
        text-align: center;
        color: rgba(107, 114, 128, 1);
        border-bottom: 1px solid #e7e7e7;
        font-size: 0.87rem;
        line-height: 1.25rem;
        padding: 0.45rem 1.25rem;
        white-space: nowrap;
    }

    tbody :deep(tr:hover td) {
        background-color: rgba(240, 240, 240, 1);
    }
</style>